module.exports = __webpack_public_path__ + "media/images/emblems/Blason_ville_CH_Bex_(Vaud)-eba29669afd4fc313403fc193ab40931.svg";